module.exports = __webpack_public_path__ + "img/pr-7.3d45640a.png";